const MAJOR_BITS = 16;
const MINOR_BITS = 12;

export function interfaceIdToFormattedVersion(interfaceId: number): string {
	const bits: string = interfaceId.toString(2).padStart(32, '0');
	const major: number = parseInt(bits.slice(0, MAJOR_BITS), 2);
	const minor: number = parseInt(bits.slice(MAJOR_BITS, MAJOR_BITS + MINOR_BITS), 2);
	const patch: number = parseInt(bits.slice(MAJOR_BITS + MINOR_BITS), 2);
	return [major, minor, patch].join('.');
}
